import Pill from '@pelckmans/elementis/components/pill';
import WarningIcon from '@pelckmans/elementis/icons/warning';
import { Result } from '../../../../../utils/results';
import { useTranslation } from 'react-i18next';

type ScoreIndicatorProps = {
  result: Result;
  showScore?: boolean;
};

const TRANSLATION_BASE = 'PAGES.RESULTS.MODALS.SMARTSCHOOL_SKORE_EXPORT.LIST';

function ScoreIndicator({ result, showScore = false }: ScoreIndicatorProps) {
  const { t } = useTranslation();

  const formatScore = (result: Result, showScore: boolean) => {
    if (!result.score || result.score.achievable === 0)
      return <span className="score">{t(`${TRANSLATION_BASE}.NO_SCORE`)}</span>;

    const { achieved, maximum } = result.score;

    if (showScore) return <span className="score">{`${achieved} / ${maximum}`}</span>;

    const percentage = (achieved / maximum) * 100;
    const score = Number.isInteger(percentage) ? percentage : percentage.toFixed(1);

    return <Pill>{`${score}%`}</Pill>;
  };

  return (
    <>
      {formatScore(result, showScore)}
      {result.isSmartschoolSynced && <Pill data-testid="skore-synced" prominence="warning" icon={<WarningIcon />} />}
    </>
  );
}

export default ScoreIndicator;
